// extracted by mini-css-extract-plugin
export default {"dav__cover_image":"ImageUpload_dav__cover_image__SfQ9S","dav__cover_image_content":"ImageUpload_dav__cover_image_content__QZKNn"};